// extracted by mini-css-extract-plugin
module.exports = {"carousel":"Carousel_carousel__IbT0Y","intersectionContainer":"Carousel_intersectionContainer__eMpi2"};